import type { StorageLocation } from "adl-gen/ferovinum/app/db";
import { DbKeySelector, type DbKeySelectorProps } from "../db-key-selector";
import { BaseWizardCard } from "./base-wizard-card";

export function DestinationWarehouseCard<T extends object>(
  props: Omit<DbKeySelectorProps<T, StorageLocation>, "label">,
) {
  return (
    <BaseWizardCard
      title="Destination Warehouse"
      subtitle="Please select the destination warehouse you would like to move your stock to."
      inputElement={
        <DbKeySelector
          {...props}
          label="Destination Warehouse"
          helperText="Can't find the warehouse?"
        />
      }
    />
  );
}
